import { render, staticRenderFns } from "./AnswerForm.vue?vue&type=template&id=cc05d738&scoped=true"
import script from "./AnswerForm.vue?vue&type=script&lang=js"
export * from "./AnswerForm.vue?vue&type=script&lang=js"
import style0 from "./AnswerForm.vue?vue&type=style&index=0&id=cc05d738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc05d738",
  null
  
)

export default component.exports